import React, { useState } from "react";
import T from "prop-types";
import { Map } from "immutable";

import { Icon } from "MODULES/shared/components";
import DropDownItem from "MODULES/shared/components/DropDown/DropDownItem";
import ConfirmAction from "MODULES/shared/components/ConfirmAction/ConfirmAction";

export default function ReleaseAccountingHold({
  managedRepairOrder,
  onConfirm
}) {
  const [confirmationIsVisible, setConfirmationVisibility] = useState(false);

  if (!managedRepairOrder.get("accounting_hold")) {
    return false;
  }

  return (
    <DropDownItem onClick={() => setConfirmationVisibility(true)}>
      <Icon name="pause" fixed />
      &nbsp;Remove Accounting Hold
      <ConfirmAction
        onConfirm={onConfirm}
        close={() => setConfirmationVisibility(false)}
        open={confirmationIsVisible}
        btnClass="btn-danger"
        btnText="Yes, Remove Accounting Hold"
        cancelText="Cancel"
        icon={<i className="fa fa-fw fa-ban" />}
      >
        <strong>Heads up!</strong>
        &nbsp; Are you sure you want to Remove the Accounting Hold?
      </ConfirmAction>
    </DropDownItem>
  );
}

ReleaseAccountingHold.propTypes = {
  managedRepairOrder: T.instanceOf(Map).isRequired,
  onConfirm: T.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/ManagedRepairOrders/Detail/ReleaseAccountingHold/ReleaseAccountingHold.jsx